import React from "react";

import { Layout } from "../components/layout/layout";
import { useAuth } from "../contexts/auth-context";
import { useTranslations } from "../hooks/use-translations";

export const DashboardPage = (): React.JSX.Element => {
  const { user } = useAuth();
  const { translations } = useTranslations();

  return (
    <Layout>
      <div className="max-w-2xl mx-auto space-y-6" data-testid="dashboard">
        <div data-testid="user-info">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100" data-testid="page-title">
            {translations.dashboard.title}
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            {translations.dashboard.welcome.replace(`{name}`, user?.firstName ?? user?.email ?? ``)}
          </p>
        </div>
      </div>
    </Layout>
  );
};
